import { createFileRoute } from "@tanstack/react-router";
import { rpcCaller } from "@crm/rpc-client";
import { RetrospectiveRpc } from "@crm/rpc-contract/groups/retrospective";

const retrospectiveRpc = rpcCaller(RetrospectiveRpc);

export const Route = createFileRoute("/_protected/class-sessions/$sessionId/retrospective")({
  head: () => ({
    meta: [{ title: "班期复盘 · imiker CRM" }],
  }),
  loader: ({ params }) =>
    retrospectiveRpc.getClassSessionRetrospectiveData({
      classSessionId: params.sessionId,
    })
});
